export type EmailValidationErrorType =
  | 'CONTAINS_FULL_WIDTH'
  | 'INVALID_FORMAT'
  | 'INVALID_DOMAIN'

// 全角ASCII（U+FF01–U+FF5E）と全角スペース（U+3000）。
const FULL_WIDTH_PATTERN = /[！-～　]/
// 簡易的なRFCチェック: 空白を含まない local@domain.tld 形式。
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// 純粋なメール形式バリデータ。最初に違反したルールを返し、問題なければ undefined。
// 文字数は cellDef.maxLength で別途検証するためここでは扱わない。
// 空・undefined はここでは有効扱い（必須チェックは別で行う）。
// emailDomainWhitelist 指定時は @以降のドメインが一覧に含まれるかも検証する
// （テナントごとの許可ドメイン。空配列は無制限）。
export const validateEmail = (
  value: string | undefined,
  emailDomainWhitelist?: string[]
): EmailValidationErrorType | undefined => {
  if (!value) return undefined
  if (FULL_WIDTH_PATTERN.test(value)) return 'CONTAINS_FULL_WIDTH'
  if (!EMAIL_PATTERN.test(value)) return 'INVALID_FORMAT'
  if (emailDomainWhitelist && emailDomainWhitelist.length > 0) {
    const domain = value.slice(value.indexOf('@') + 1)
    if (!emailDomainWhitelist.includes(domain)) return 'INVALID_DOMAIN'
  }
  return undefined
}
